import React, { useState, useEffect } from 'react';
import Fetch from '../../../../../core/util/core/Fetch';
import config from '../../../../config/config';
import { useSelector } from 'react-redux';

import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from 'reactstrap';
import classnames from "classnames";

import '../home/Home.css';

const Emendation = (props) => {
  const sessionSelector = useSelector((state) => { return state.core.session });
  const friendly_url = sessionSelector.pdc_project_friendly_url;

  const [emendations, setEmendations] = useState('')

  useEffect(() => {
    const loadData = async () => {
      const emendationsData = await Fetch.post(`${config.endpoints.backend}portal/getallemendations`, { filter: { friendly_url } })

      setEmendations(emendationsData)
    };

    loadData();
  }, [])

  const [open, setOpen] = useState('0');
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    (emendations && emendations != '') && (
      <div className="ml-4 mt-3 mr-4 pt-3 height-100vh">
        {Object.entries(emendations).map(([modalityName, records], modalityIndex) => (
          <div key={modalityIndex} className="mb-3">
            <h3>{modalityName.split('-')[0]}</h3>

            <Accordion open={open} toggle={toggle}>
              {records.map((process, processIndex) => (
                <AccordionItem
                  key={process.id}
                  className={classnames({ open: open === `${modalityName}-${processIndex}`, closed: open !== `${modalityName}-${processIndex}` })}
                >
                  <AccordionHeader targetId={`${modalityName}-${processIndex}`}>
                    Instrumento Nº {process.instrument_number} - {process.object}
                  </AccordionHeader>
                  <AccordionBody accordionId={`${modalityName}-${processIndex}`}>
                    <div className="mb-2">
                      <strong>Descrição:</strong> {process.object}
                    </div>
                    <div className="mb-2">
                      <strong>Período:</strong> {process.start_validity} até {process.end_validity}
                    </div>
                    <div className="mb-2">
                      <strong>Autor:</strong> {process.author}
                    </div>
                    <div className="mb-2">
                      <strong>Concedente:</strong> {process.grantor}
                    </div>
                    <div className="mt-4">
                      <span className="font-semibold">Anexos:</span>
                      <ul className="list-disc list-inside">
                        {(process.files && process.files.length > 0) ? process.files.map((file, fileIndex) => (
                          <li key={fileIndex}>
                            <a href={file.files3} download target="_blank" rel="noopener noreferrer">
                              {file.filename}
                            </a>
                          </li>
                        )) : 'Não há anexos'}
                      </ul>
                    </div>
                  </AccordionBody>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        ))}
      </div>
    )
  );
};

export default Emendation;